<template>
    <div class="page-content header-clear">  
        <div class="bali_detail">
            <div class="responsive-iframe bottom-20">
                <iframe src='https://www.youtube.com/embed/m3b1oRTACzE' frameborder='0' allowfullscreen></iframe>
            </div>
            <div class="clear"></div>  
            <div class="content">
                <ExploreTitle   
                    title="Bali" 
                    positionSlide2="130px"
                    image="explore/silver.png" 
                    color="#2f6f7e"
                    description1="2021 Ace Convention Silver"
                    description2="Challenge Period: 1 JAN to 31 DEC, 2021"
                    link="bali"/>
            </div>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
import ExploreTitle from '../../components/ExploreTitle.vue'
export default {
    name: 'Bali',
    components: {
        ExploreTitle
    }
}
</script>